// eslint-disable-next-line import/named
import { AxiosInstance } from "axios";

type APIParams = {
  method: "GET" | "POST" | "DELETE";
  url: string;
  data?: Record<string, any>;
};

class CoreAPI {
  instance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.instance = axiosInstance;
  }
  async call<T>(params: APIParams) {
    const { method, url, data } = params;

    const response = await this.instance(url, {
      method,
      data,
    });
    if (response.data.data) {
      return response.data.data as T;
    }
    return response.data as T;
  }
}

export default CoreAPI;
